var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 55,
    viewBox: "0 0 42 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6111 0C5.87986 0 -4.08524 14.429 1.6408 27.4682L9.83732 46.133C11.6649 50.2947 15.7982 55 20.5 55C25.2018 55 29.5573 50.2946 31.3849 46.133L39.5814 27.4682C45.3075 14.429 35.3424 0 20.6111 0ZM20.613 29.4444C26.0335 29.4444 30.4278 25.0501 30.4278 19.6296C30.4278 14.209 26.0335 9.81474 20.613 9.81474C15.1924 9.81474 10.7981 14.209 10.7981 19.6296C10.7981 25.0501 15.1924 29.4444 20.613 29.4444Z",
    fill: "#CA1211"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.1f7c7e5c5e18ec66c38f7110e06622df.svg";
export { ForwardRef as ReactComponent };